import { create } from 'zustand';

interface IUsersPermissionsModel {
  permissions: string[];
  isAdmin: boolean;
}

type Store = {
  permissions: string[];
  isAdmin: boolean;
  IsAllowed: (requiredPermissions: string[]) => boolean;
  setData: (data: IUsersPermissionsModel) => void;
};

export const useApplicationUserRightsStore = create<Store>()((set, get) => ({
  permissions: [],
  isAdmin: false,
  IsAllowed: (requiredPermissions: string[]) => requiredPermissions.every((v) => get().permissions.includes(v)),
  setData: (data: IUsersPermissionsModel) => set(() => ({ permissions: data.permissions, isAdmin: data.isAdmin })),
}));
